(function($){
  $(document).ready(function() {

    $('#print-page').click(function(e){
        e.preventDefault();
        window.print();
    });

    $("body").on("click", "a", function(e){
        var href = $(this).attr("href");
        if (href != undefined){
            if ( (href.substring(0,4) == "http" && href.indexOf(MY_HTTP_HOST) == -1 ) || href.indexOf('.pdf') != -1){
                e.preventDefault();
                window.open(href);
            }
        }
    })

  })
})(jQuery);